import React from "react";
import "./Promise.scss";

const PromiseWall = () => {
  return (
    <section className="section promise-wall">
      <div className="section__title section__title--testimonials text-center">
        <h2 className="section__description white">Promise of the year 2026</h2>
        <h2 className="promise-text text-white my-32">
          'Your sun will never set again,
    and your moon will wane no more;
the Lord will be your everlasting light,
    and your days of sorrow will end.'
        </h2>
        <h2 className="text-white text-3xl">Isaiah 60:20</h2>
      </div>
    </section>
  );
};

export default PromiseWall;
